import { IconButton } from 'office-ui-fabric-react';
import {
  getInvitationKeyDisplayValue,
  getInvitationKeyType,
} from '../../utility/useFilterAndSort';

function columns(translator, removeInvitationKey) {
  return [
    {
      key: 'displayValue',
      name: translator('components.inviteeForm.keyColumn'),
      ariaLabel: translator('components.inviteeForm.keyColumn'),
      fieldName: 'displayValue',
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
      onRender: (item) => getInvitationKeyDisplayValue(item),
    },
    {
      key: 'type',
      name: translator('components.inviteeForm.typeColumn'),
      ariaLabel: translator('components.inviteeForm.typeColumn'),
      fieldName: 'type',
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
      onRender: (item) => getInvitationKeyType(item),
    },
    {
      key: 'removeInvitationKey',
      name: '',
      ariaLabel: translator('global.delete'),
      minWidth: 50,
      maxWidth: 50,
      onRender: (item) => (
        <IconButton
          iconProps={{ iconName: 'Delete' }}
          title={translator('global.delete')}
          ariaLabel={translator('global.delete')}
          onClick={() => removeInvitationKey(item)}
        />
      ),
    },
  ];
}

export { columns };
